module.exports = __webpack_public_path__ + "img/zsgg-12.cb6d28fa.png";